module.exports = __webpack_public_path__ + "img/individual-1.497bb8a.png";